import React from 'react';
import { SignUpContainer } from '../../../components/modules/Account/SignUp/SignUp';

export const SignUp = () => <SignUpContainer />;
